import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, find } from 'lodash';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PROVINCES } from 'financing/constants/localization';

const AddressDisplay = ({ address, address2, city, country, postalCode, province }) => {
    let provinceTransKey = '';
    if (province) {
        provinceTransKey = find(PROVINCES, (i) => i.value === province.toLowerCase()).transKey;
    }
    return (
        <div className="personalInfo">
            <span>
                {!isEmpty(address) && address}
                {!isEmpty(address2) && ` ${address2},`}
            </span>
            <span>{!isEmpty(city) && city}</span>
            <span>
                {!isEmpty(province) && LocaleService.t(provinceTransKey)}
                {!isEmpty(country) && ` ${country},`}
            </span>
            <span>{!isEmpty(postalCode) && postalCode}</span>
        </div>
    );
};

AddressDisplay.propTypes = {
    address: PropTypes.string.isRequired,
    address2: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    province: PropTypes.string.isRequired,
};

AddressDisplay.displayName = 'AddressDisplay';

export default AddressDisplay;
